import React from "react";
import useLanguageChange from "../../hooks/useLanguageChange";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import markupService from "../../services/MarkupService/markupService";
import { MARKUP_MENU_TYPE } from "../../constants/MarkupConstants";
import UploadFileMarkupService from "../../services/UploadFileMarkupService/UploadFileMarkupService";

const RedoButton = ({ fromMarkup }) => {
    const localisedValues = useLanguageChange();
    const { redoEnabled } = useSelector((state) => state.markup);
    return (
        <div className='markup-menu-item right-border' data-testid='markup-edit-menu-bar'>
            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                <button
                    className='btn markup-menu-btn'
                    onClick={() => {
                        fromMarkup === MARKUP_MENU_TYPE.MARKUP_ANNOTATION
                            ? markupService.redoLocalObject()
                            : UploadFileMarkupService.redoMarkupLocalObject();
                    }}
                    disabled={!redoEnabled}
                    data-testid='markup-edit-menu-button'
                >
                    <span className='btn-icon icon-redo'></span>
                    <span className='moremenu-text'>{localisedValues?.redo}</span>
                </button>
                <div className='custom-tooltip-content text-nowrap'>
                    <div className='custom-tooltip-in'>
                        <p>{localisedValues?.redo}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

RedoButton.propTypes = {
    fromMarkup: PropTypes.string,
};
export default RedoButton;
